import { useContext } from 'react';

import { QuotationGroups } from '../../../utils';
import { QuotationInfoContext } from '../../contexts/QuotationInfo';

import { WizardAP } from '../../../AP/Wizard';
import { WizardFire } from '../../../Fire/Wizard';
import { WizardLifeObligatory } from '../../../ObligatoryLife/Wizard';

import { WizardConsortiumIntegral } from '../../../ConsortiumIntegral/Wizard';
import { WizardCivilResponsibility } from '../../../CivilResponsibility/Wizard';
import { WizardCommerce } from '../../../Commerce/Wizard';
import { WizardHome } from '../../../HomeProduct/Wizard';
import { WizardPersonalEffects } from '../../../PersonalEffects';
import { WizardCar } from '../../../Car';
import { WizardTheftInsurance } from '../../../TheftInsurance';


export const StepContainer = () => {

  const { quotationInfo }  = useContext( QuotationInfoContext )

  const getQuotationProduct = () => {
    switch ( quotationInfo?.groupSelected ) {
      case QuotationGroups.AP:
        return <WizardAP />
      case QuotationGroups.INCENDIO:
        return <WizardFire />
      case QuotationGroups.VIDA_OBLIGATORIA:
        return <WizardLifeObligatory />
      case QuotationGroups.INTEGRAL_CONSORCIO:
        return <WizardConsortiumIntegral />
      case QuotationGroups.RESPONSABILIDAD_CIVIL:
        return <WizardCivilResponsibility />
      case QuotationGroups.INTEGRAL_COMERCIO:
        return <WizardCommerce />
      case QuotationGroups.HOGAR:
        return <WizardHome />
      case QuotationGroups.EFECTOS_PERSONALES:
        return <WizardPersonalEffects />
      case QuotationGroups.AUTOMOVILES:
        return <WizardCar />
      case QuotationGroups.ROBO:
        return <WizardTheftInsurance />
    }
  }

  return (
    <div style={{ width: '100%', paddingBottom: '2rem' }}>
        {getQuotationProduct()}
    </div>
  );
};

